import { asNumber } from './detailShared'
// ADDENDUM 33 (E39), punto 8 — cuánto se ha desviado el tiempo REAL del TEÓRICO.
//
// ⚠️ ES UNA MAGNITUD, NO UN PORCENTAJE, y la decisión se tomó con un dato delante: EL 44% DE LOS
// TIEMPOS TEÓRICOS POSITIVOS VALE EXACTAMENTE 1 SEGUNDO — 1.487 tareas de 3.370 (addendum 16 C),
// casi con seguridad un valor por defecto de importación. Un ratio sobre un divisor de 1 s da
// "+1.870.000%", que no informa de nada: ensucia la pantalla y desacredita el dato bueno de al lado.
//
// Tres razones por las que la magnitud absoluta es la forma correcta y no un apaño:
//   · NO EXPLOTA, porque no hay divisor. `real 5h12' · teórico 1s` da "+5h 12'", que es verdad.
//   · NO EXIGE UNA REGLA DE CREDIBILIDAD. El PO descartó expresamente inventar "qué teórico es
//     creíble", y RN8 manda: el contrato dice que un teórico de 1 s es sospechoso de defecto de
//     datos y que SE SIRVE TAL CUAL sin interpretarlo, porque no hay ninguna señal que lo declare
//     ausente. Un umbral aquí sería justo esa interpretación.
//   · DEJA LA RAREZA A LA VISTA. El teórico sigue pintado al lado, así que quien lea "teórico 1s ·
//     real 5h12' (+5h 12')" puede juzgar el dato. Esconderlo sería decidir por él.
//
// Es además la forma que YA usa la cabecera de la ficha: dice "Late by 83 days", una magnitud, y no
// un porcentaje de retraso.
//
// ⚠️ Y `{ computable: false }` NO ES CERO. Mismo contrato que `deviationLabel.js`, y por la misma
// razón: la cabecera pinta el literal de "no calculable" y NUNCA "0 días" ni "a tiempo". Una
// desviación que no se puede calcular y una desviación nula son dos hechos distintos, y el segundo
// afirma algo que el primero no sabe.

/**
 * @param {number|string|null} theoreticalSeconds el teórico tal cual lo sirve N4 (`''` si falta)
 * @param {number|string|null} actualSeconds el real tal cual lo sirve N4 (`''` si falta)
 * @returns {{computable: boolean, deltaSeconds: number}} `deltaSeconds` va CON SIGNO: positivo si
 *   se tardó de más, negativo si de menos, cero si coincidieron exactamente. El signo lo interpreta
 *   quien pinta, que es quien tiene el `t_`.
 */
export const timeDeviation = (theoreticalSeconds, actualSeconds) => {
  const theoretical = asNumber(theoreticalSeconds)
  const actual = asNumber(actualSeconds)
  // Falta cualquiera de las dos: no hay resta que hacer. Es la única condición, y es aritmética —
  // no un juicio sobre si el número que hay merece confianza.
  if (theoretical === null || actual === null) {
    return { computable: false, deltaSeconds: 0 }
  }
  return { computable: true, deltaSeconds: actual - theoretical }
}
